import React from 'react';
import { useTranslation } from 'react-i18next';
import { localeConfig } from '../i18n';
import logo from '../assets/logo.png';

const Footer = () => {
  const { t, i18n } = useTranslation(['brand', 'footer']);
  const brandTrademark = t('brand.trademark', { ns: 'brand' });
  const privacyLabel = t('footer.privacy', { ns: 'footer' });
  const termsLabel = t('footer.terms', { ns: 'footer' });
  const cookieLabel = t('footer.cookie', { ns: 'footer' });
  const copyrightLabel = t('footer.copyright', { ns: 'footer' });
  const year = new Date();
  const currentLang = i18n.language;

  const buildPath = (slug = '') => {
    // Если это язык по умолчанию, не добавляем префикс
    if (currentLang === localeConfig.defaultLocale) {
      return slug ? `/${slug}` : '/';
    }
    
    // Для других языков добавляем префикс
    return slug ? `/${slug}/${currentLang}` : `/${currentLang}`;
  };

  return (
    <footer id='contact' className='w-100 flex jcc aic bg-light'>
      <div className='container'>
        <div className='px-5 mx-3'>
          <div className='s-64'></div>
          <div className='flex jcsb aic h-10 py-5 footer-bar'>
            <a href={buildPath()} aria-label='Logotype' className='flex aic'>
              <img src={logo} width={162} height={162} alt={brandTrademark} />
            </a>
            <nav
              className='flex aic'
              style={{ gap: '24px', flexWrap: 'nowrap', justifyContent: 'flex-end' }}
            >
              <a
                href={buildPath('privacy-policy')}
                className='title-mini mx-3 px-1'
                style={{ whiteSpace: 'nowrap' }}
              >
                {privacyLabel}
              </a>
              <a
                href={buildPath('terms-of-use')}
                className='title-mini mx-3 px-1'
                style={{ whiteSpace: 'nowrap' }}
              >
                {termsLabel}
              </a>
              <a
                href={buildPath('cookie-policy')}
                className='title-mini mx-3 px-1'
                style={{ whiteSpace: 'nowrap' }}
              >
                {cookieLabel}
              </a>
            </nav>
          </div>
          <div className='s-32'></div>
          <div className='s-1 bg-grey'></div>
          <div className='s-40'></div>
          <div className='tc'>
            <span className='title-mini'>
              <a href={buildPath()}>{brandTrademark}</a> @ {year.getFullYear()} - {copyrightLabel}
            </span>
          </div>
          <div className='s-40'></div>
        </div>
      </div>
    </footer>
  );
};

export { Footer };
